import { Component, EventEmitter, Input, Output, OnDestroy, HostListener } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslatePipe } from "../../pipe/translation.filter.pipe";
import { ApeButtonComponent } from "../ape-button/ape-button.component";
import { DrawerModule } from "primeng/drawer";
import { TRANSLATION_KEYS } from "../../constants/translations/translation-keys";
import { AutoFocusModule } from "primeng/autofocus";
import { FocusTrapModule } from "primeng/focustrap";
import { BadgeModule } from "primeng/badge";

@Component({
  selector: "ape-drawer",
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    ApeButtonComponent,
    DrawerModule,
    AutoFocusModule,
    FocusTrapModule,
    BadgeModule
  ],
  templateUrl: "./ape-drawer.component.html"
})
export class ApeDrawerComponent implements OnDestroy {
  readonly TRANSLATION_KEYS = TRANSLATION_KEYS;

  private static instanceCounter = 0;

  protected readonly componentId = `drawer-${ApeDrawerComponent.instanceCounter++}`;

  @Input({ required: true })
  visible!: boolean;

  @Input({ required: true })
  title!: string;

  @Input()
  position: "left" | "right" = "right";

  @Input()
  closable: boolean = false;

  @Input()
  dismissible: boolean = true;

  @Input()
  styleClass: string = "min-w-full w-full md:min-w-[600px] [&>.p-drawer-header]:!p-0 [&>.p-drawer-content]:!p-[20px_24px] [&>.p-drawer-header]:sm:!p-0 [&>.p-drawer-content]:sm:!p-[40px_60px_20px_60px]";

  @Input()
  cssTitleClass: string = "";

  @Input()
  headerBadgeSeverity: "info" | "success" | "danger" | "warn" | "secondary" | "contrast" | "none" = "none";

  @Input()
  headerbadgeCounter: number | undefined = undefined;

  @Output()
  visibleChange = new EventEmitter<boolean>();

  @Output()
  closeClick = new EventEmitter<void>();

  @HostListener("document:keydown.escape", ["$event"])
  protected onEscapeKey(event: KeyboardEvent): void {
    // Intercetta ESC solo se il drawer è visibile
    if (this.closable) {
      if (this.visible) {
        event.preventDefault();
        event.stopPropagation();

        // Chiama onCloseClick per notificare il parent
        this.onCloseClick();
      }
    }
  }

  protected onCloseClick(): void {
    this.closeClick.emit();
  }

  protected onVisibleChange(visible: boolean): void {
    this.visible = visible;
    this.visibleChange.emit(visible);
  }

  ngOnDestroy(): void {
  }

  get drawerTitle(): string {
    return `${this.componentId}-title`;
  }

  get headerCounterValue(): number {
    if (this.headerbadgeCounter) {
      return +this.headerbadgeCounter;
    }
    return 0;
  }
}
